import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const AllBlogs = () => {
  return (
    <div className="my-5">
      <Container>
        <h2
          style={{ marginTop: "85px" }}
          className="mb-5 text-center project-title"
        >
          Check Out My Blogs
        </h2>
        <Row xs={1} md={3} className="g-4">
          {/* ----------------------
        ----------Blog one-----------
        ---------------------------*/}
          <Col>
            <Card className="service-card">
              <Card.Img
                className="card-img"
                variant="top"
                src={"https://i.ibb.co/H79dpJc/5491136649494528.jpg"}
              />
              <Card.Body>
                <h4 className="project-title">CSS Flexbox Layout</h4>
                <Card.Text>
                  <b> Flexbox:</b> In CSS flexbox is used to arranging items in
                  row or columns. Before flexbox developer used to design layout
                  with float and positioning. And it was very hard to arrange.
                  But using flexbox it became very easy and flexible.
                </Card.Text>
                <Link to="/blog_one">
                  <button className="primary-btn">Read More</button>
                </Link>
              </Card.Body>
            </Card>
          </Col>
          {/* ----------------------
        ----------Blog Two-----------
        ---------------------------*/}
          <Col>
            <Card className="service-card">
              <Card.Img
                className="card-img"
                variant="top"
                src={"https://i.ibb.co/6t8Qfwt/SEO-challenge-in-Reactjs.jpg"}
              />
              <Card.Body>
                <h4 className="project-title">Is React Good For SEO?</h4>
                <Card.Text>
                  Is react good for <b>SEO?</b> The answer is not
                  straightforward. It depends on how you build your website. If
                  you build a simple react website. Then it will be very bad for{" "}
                  SEO. Though you use meta tag, alt tag, and complete every
                  on-page SEO...
                </Card.Text>
                <Link to="/blog_two">
                  <button className="primary-btn">Read More</button>
                </Link>
              </Card.Body>
            </Card>
          </Col>
          {/* ----------------------
        ----------Blog Three-----------
        ---------------------------*/}
          <Col>
            <Card className="service-card">
              <Card.Img
                className="card-img"
                variant="top"
                src={"https://i.ibb.co/82KG2bk/download.png"}
              />
              <Card.Body>
                <h4 className="project-title">
                  CRUD operations in MongoDB with Node JS
                </h4>
                <Card.Text>
                  CRUD operations are the basic methods of interacting with
                  MongoDB database via server. CRUD stands for Create, Read,
                  Update and Delete.This method is the basic...
                </Card.Text>
                <Link to="/blog_three">
                  <button className="primary-btn">Read More</button>
                </Link>
              </Card.Body>
            </Card>
          </Col>
          {/* ----------------------
        ----------Blog Four-----------
        ---------------------------*/}
          <Col>
            <Card className="service-card">
              <Card.Img
                className="card-img"
                variant="top"
                src={"https://i.ibb.co/x8qDRw7/dom-in-js.jpg"}
              />
              <Card.Body>
                <h4 className="project-title">Javascript HTML DOM Method</h4>
                <Card.Text>
                  <b>The Javascript HTML DOM : </b> The Javascript DOM is a
                  method that allows scripts to dynamically access the HTML and
                  update the content, structure, and style of a document...
                </Card.Text>
                <Link to="/blog_four">
                  <button className="primary-btn">Read More</button>
                </Link>
              </Card.Body>
            </Card>
          </Col>
          {/* ----------------------
        ----------Blog Five-----------
        ---------------------------*/}
          <Col>
            <Card className="service-card">
              <Card.Img
                className="card-img"
                variant="top"
                src={"https://i.ibb.co/611VLVs/download-1.png"}
              />
              <Card.Body>
                <h4 className="project-title">5 Facts about JavaScript</h4>
                <Card.Text>
                  Javascript is a single-threaded asynchronous programming
                  language. It runs code line by line. It is a high-level
                  programming language. That means it is very understandable to
                  human language. It is used in the browser engine. It...
                </Card.Text>
                <Link to="/blog_five">
                  <button className="primary-btn">Read More</button>
                </Link>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AllBlogs;
